import Vue from 'vue'
import Router from 'vue-router'

import ContentUnit from '@/views/components/ContentUnit.vue'
import ContentUnitSingle from '@/views/components/ContentUnitSingle.vue'
import Korkeakoulu from '@/views/Korkeakoulu'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/es/pagina-de-inicio'
    },
    {
      path: '/:locale',
      component: {
        template: '<router-view />',
      },
      /* this never worked
      beforeEnter: (to, from, next) => {
        const lang = to.params.locale
        // $i18n.locale = lang
        return next()
      }, */
      redirect: '/:locale/pagina-de-inicio',
      children: [
      {
        path: 'pagina-de-inicio',
        name: 'Korkeakoulu',
        component: Korkeakoulu
      },
      {
        path: 'los-derechos-de-propiedad-intelectual',
        name: 'Los derechos de propiedad intelectual',
        component: ContentUnit,
        props: {
          pid: 9,
          pids: [654,1022,1023,1024],
          colorclass: 'template-red',
          herosrc: 1
        }
      },
      {
        path: 'que-significan-los-derechos-de-autor',
        name: 'Qué significan los derechos de autor',
        component: ContentUnit,
        props: {
          pid: 25,
          pids: [641,821,822,823],
          colorclass: 'template-blue',
          herosrc: 2
        }
      },
      {
        path: 'la-cesion-de-los-derechos-de-autor',
        name: 'La cesión de los derechos de autor',
        component: ContentUnit,
        props: {
          pid: 26,
          pids: [655,877,878,879],
          colorclass: 'template-yellow',
          herosrc: 3
        }
      },
      {
        path: 'uso-de-las-obras',
        name: 'Uso de las obras',
        component: ContentUnit,
        props: {
          pid: 27,
          pids: [656,918,919,920],
          colorclass: 'template-green',
          herosrc: 4
        }
      },
      {
        path: 'produccion-personal',
        name: 'Producción personal',
        component: ContentUnit,
        props: {
          pid: 28,
          pids: [657,789,806,807],
          colorclass: 'template-purple',
          herosrc: 5
        }
      },
      {
        path: 'info',
        name: 'Info',
        component: ContentUnitSingle,
        props: {
          pid: 763,
          pids: [763,1132,991,1133],
          colorclass: '',
          herosrc: 0
        }
      },
      {
        path: 'autores',
        name: 'Autores',
        component: ContentUnitSingle,
        props: {
          pid: 684,
          pids: [684,782,1119,985],
        }
      },
      {
        path: 'condiciones-de-uso',
        name: 'Condiciones de uso',
        component: ContentUnitSingle,
        props: {
          pid: 685,
          pids: [685,978,980,981],
        }
      },
      {
        path: 'cookies',
        name: 'Cookies',
        component: ContentUnitSingle,
        props: {
          pid: 687,
          pids: [687,982,983,984],
        }
      },
      {
        path: 'politica-de-privacidade',
        name: 'Politica de privacidade',
        component: ContentUnitSingle,
        props: {
          pid: 1122,
          pids: [1122,1100,1101,1102],
        }
      },
      {
        path: 'accesibilidade',
        name: 'Accesibilidade',
        component: ContentUnitSingle,
        props: {
          pid: 1123,
          pids: [1123,1125,1126,1127],
        }
      },
      {
        path: 'osaamismerkki',
        name: 'Osaamismerkki',
        component: ContentUnitSingle,
        props: {
          pid: 707,
          pids: [707,809,814,817],
        }
      },
      {
        path: 'yhteystiedot',
        name: 'Yhteystiedot',
        component: ContentUnitSingle,
        props: {
          pid: 686,
          pids: [686],
        }
      },
      {
        path: 'opettajalle',
        name: 'Opettajalle',
        component: ContentUnitSingle,
        props: {
          pid: 699,
          pids: [699,972,973,974],
        }
      }
    ]}
  ],
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js